const LoadingState = ({ message = "Loading…", variant = "primary" }) => (
  <div className="d-flex flex-column align-items-center justify-content-center py-5">
    <div
      className={`spinner-border text-${variant}`}
      role="status"
      style={{ width: "3rem", height: "3rem" }}
    >
      <span className="visually-hidden">{message}</span>
    </div>
    <p className="mt-3 mb-0 text-muted">{message}</p>
  </div>
);

export default LoadingState;
